import { ChevronRightIcon, Flex, Typography } from '@iheartjane/reefer';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import type { FilterGroup } from '@jane/search/types';

interface FilterTypeaheadProps {
  filterGroup: FilterGroup;
}

export const FilterTypeahead = ({ filterGroup }: FilterTypeaheadProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToTypeahead = useCallback(() => {
    navigate(`${location.pathname}/${filterGroup.key}`);
  }, [filterGroup, location, navigate]);

  if (!filterGroup.typeahead) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      ariaLabel={`filter by ${filterGroup.label}`}
      justifyContent="space-between"
      onClick={navigateToTypeahead}
    >
      <Typography variant="header-bold">{filterGroup.label}</Typography>
      <ChevronRightIcon />
    </Flex>
  );
};
